import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';

const getDuration = ({ start, end, expected }) => {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(duration);

  const now = dayjs();
  const startDate = dayjs.utc(start);
  const endDate = dayjs.utc(end ?? now);

  const expectedDate = dayjs.utc(expected);

  // Create a duration object from the difference in milliseconds
  const diff = dayjs.duration(endDate.diff(startDate));

  // Create a duration object from the difference in milliseconds
  const oddiff = dayjs.duration(now.diff(expectedDate));

  const d = Math.floor(diff.asDays()); // Total days (e.g., 1)
  const h = Math.floor(diff.asHours() % 24); // Remaining hours (0-23)
  const m = diff.minutes(); // Remaining minutes (0-59)
  const totalM = diff.asMinutes();

  // Get individual components
  const odD = Math.floor(oddiff.asDays()); // Total days (e.g., 1)
  const odH = Math.floor(oddiff.asHours() % 24); // Remaining hours (0-23)
  const odM = oddiff.minutes(); // Remaining minutes (0-59)

  return {
    // Get individual components
    days: d,
    hours: h,
    mins: m,
    totalMins: totalM,
    isComplete: !!end,
    isOverdue: oddiff > 0,
    isLate: oddiff > 0 && Math.floor(oddiff.asHours()) === 0,
    durationText: `${d > 0 ? `${d}d ` : ' '}${h}h ${m}m`,
    odDays: odD,
    odHours: odH,
    odMins: odM,
    overdueText: `${odD > 0 ? `${odD}d ` : ' '}${odH}h ${odM}m`,
  };
};

export default getDuration;
